// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"655367be","977":"ba583fde"}[chunkId] + ".chunk.js";
};